import AdminServicesPageComponent from "./components/AdminServicesPageComponent";

import axios from "axios";

const fetchServices = async (abctrl) => {
    const { data } = await axios.get("/api/services/admin", {
        signal: abctrl.signal,
    })
    return data;
}

const deleteService = async (serviceId) => {
    const { data } = await axios.delete(`/api/services/admin/${serviceId}`);
    return data
}

const AdminServicesPage = () => {
  return <AdminServicesPageComponent fetchServices={fetchServices} deleteService={deleteService} />
};

export default AdminServicesPage;
